module.exports = __webpack_public_path__ + "img/logo-app-white.3e2994c6.svg";